import { arrayToObject, deleteProperty } from "@/services/helpers";

export const initViews = (state, payload) => {
  state.views = arrayToObject(payload, "id");
  state.loaded = true;
};

export const addView = (state, payload) => {
  state.views = { ...state.views, [payload.id]: payload };
};

export const updateView = (state, payload) => {
  state.views[payload.id] = { ...state.views[payload.id], ...payload };
};

export const updateViewLayout = (state, { id, layout }) => {
  if (state.views[id]) {
    state.views[id] = { ...state.views[id], layout };
  }
};

export const deleteView = (state, id) => {
  state.views = deleteProperty(state.views, id.toString());
};

export const setActiveViewId = (state, id) => {
  state.activeViewId = id;
};

export const setLoading = (state, payload) => {
  state.loading = payload;
};

export const reset = (state) => {
  state.views = {};
  state.activeViewId = null;
  state.loading = false;
  state.loaded = false;
};
